<template>
  <div
    v-if="isVisible"
    class="modal show d-block fade"
    tabindex="-1"
    style="background: rgba(0,0,0,0.5)"
  >
    <div class="modal-dialog">
      <div class="modal-content modal-thin-header">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>

        <div class="modal-body bg-white">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FormModal',

  props: {
    title: {
      type: String,
      default: 'Fill In Form',
    },
    size: {
      type: String,
      default: 'modal-md',
    },
  },

  emits: ['close'],

  data() {
    return {
      isVisible: false,
    }
  },

  provide() {
    return {
      formGuard: {
        markDirty: () => {},
        markClean: () => {},
        requestClose: () => this.closeModal(),
      },
    }
  },

  methods: {
    showModal() {
      this.isVisible = true
    },

    closeModal() {
      this.isVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
/* Modal container – 70% width */
.modal-dialog {
  max-width: 70%;
  width: 70%;
  margin: 1.75rem auto;
  display: flex;
  align-items: center;
  min-height: calc(100% - 3.5rem);
}

@media (max-width: 992px) {
  .modal-dialog {
    max-width: 85%;
    width: 85%;
  }
}

@media (max-width: 576px) {
  .modal-dialog {
    max-width: 95%;
    width: 95%;
    margin: 0.5rem auto;
  }
}

</style>